import { mixpanel } from '@fiverr-private/obs';

export interface MixpanelEventData {
    eventName: string;
    categoryName?: string;
    guideName?: string;
    guideUrl?: string;
    guideLocation?: number;
    linkUrl?: string;
}

export const sendMixpanelEvent = (data: MixpanelEventData): void => {
    const eventData: Record<string, any> = {
        'Page name': 'Category',
    };

    if (data.categoryName) {
        eventData['Category Name'] = data.categoryName.split('_')[1];
    }
    if (data.guideName) eventData['Guide name'] = data.guideName;
    if (data.guideUrl) eventData['Guide URL'] = data.guideUrl;
    if (data.guideLocation) eventData['Guide location'] = data.guideLocation;
    if (data.linkUrl) eventData['Link URL'] = data.linkUrl;

    mixpanel.track(data.eventName, eventData);
};
